<template>
    <div class="block-content block-content-full mt-4 mb-1 pb-0 overflow-hidden">
        <div class="w-80">
            <div class="block-header pt-2">
                <h3 class="text-center block-title fs-5 fw-semibold text-light-blue">{{ $t('customer.general_info') }}</h3>
            </div>
            <div class="row justify-content-center py-md-4 py-lg-4">
                <div class="col-sm-10 col-md-8">
                    <div class="">
                        <div class="row">
                            <div class="col-12 text-center">
                                <p class="ppv2-text-black fs-6 fw-normal">
                                    {{ $t('customer.sms_send_info', { total: totalCustomer, symbol: $symbolCurrency }) }}
                                    <small class="text-muted fw-normal fs-sm">{{ $t('customer.char_limit_note') }}</small>
                                </p>
                            </div>
                            <div class="col-12">
                                <label class="form-label" for="description"
                                    >{{ $t('customer.message_label') }}<span class="text-purple">*</span></label
                                >

                                <textarea
                                    class="form-control"
                                    maxlength="150"
                                    rows="12"
                                    :placeholder="$t('customer.sms_placeholder')"
                                    v-model="content"
                                    style="margin-top: 0px; margin-bottom: 0px; height: 114px"
                                >
                                </textarea>

                                <p class="text-end pt-2">
                                    <small class="text-muted fw-normal fs-sm">{{
                                        $t('customer.chars_remaining', { count: remainingCharacters })
                                    }}</small>
                                </p>
                            </div>

                            <div class="col-12 pt-0">
                                <div class="dropdown d-inline-block">
                                    <button
                                        type="button"
                                        class="dropdown-button btn-dark height40 rounded-12 fs-sm fw-semibold px-4"
                                        id="page-header-action-dropdown"
                                        data-bs-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="true"
                                        style="height: 40px !important"
                                    >
                                        {{ $t('customer.variables') }}
                                    </button>
                                    <div
                                        class="dropdown-menu dropdown-action dropdown-menu-end rounded-24 dropdown-variable-menu"
                                    >
                                        <a
                                            class="btn btn-sm btn-action m-1"
                                            v-for="(_var, index) in variables"
                                            :key="index"
                                            @click="insertVariable(_var.content)"
                                            >{{ _var.name }}</a
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-center py-3 my-4 mb-0">
                        <button
                            @click="sendSms()"
                            :disabled="isLoadingSendingSms"
                            class="btn btn-dark rounded-12 fw-semibold width-btn height_btn_page"
                        >
                            <span v-if="!isLoadingSendingSms">{{ $t('customer.send') }}</span>
                            <span v-else>{{ $t('customer.loading') }}</span>
                        </button>
                    </div>

                    <div class="d-flex justify-content-center py-3 my-4" v-if="result">
                        <p v-if="result.message">{{ result.message }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import state from './Api/state.js'
import ApiManager from './Api/ApiManagerBoCutomer.js'

export default {
    name: 'CustomerSms',
    components: {},
    data: () => ({
        content: '',
        isLoadingSendingSms: false,
        totalCustomer: state.customers?.total ? state.customers?.total : 0,
        variables: [
            { name: '{{first_name}}', content: '{{first_name}}' },
            { name: '{{last_name}}', content: '{{last_name}}' },
        ],
        result: '',
        maxCharacters: 150,
    }),
    computed: {
        characterCount() {
            return this.content.length
        },
        remainingCharacters() {
            return this.maxCharacters - this.characterCount
        },
    },
    methods: {
        insertVariable(content) {
            this.content += content
        },

        async sendSms() {
            const payload = {
                description: this.content,
                insert_id: '-1',
            }

            try {
                this.isLoadingSendingSms = true
                this.result = await ApiManager.sendSms(payload)
            } catch (error) {
                this.$toast.error(error.response.data.message)
                //
            } finally {
                this.isLoadingSendingSms = false
                this.content = ''
            }
        },
    },
}
</script>

<style scoped>
.dropdown-variable-menu {
    inset: 19px auto auto 78px !important;
}
</style>
